<div id="banner_el" class="fz-banner">
  <!-- Background banner image -->
  <div class="fz-banner__background-image">
    <picture>
      @if (bannerImage().md) {
        <source
          media="(min-width:768px) and (max-width:992px)"
          [attr.srcset]="bannerImage().md"
          class="ng-star-inserted"
        />
      }
      @if (bannerImage().sm) {
        <source
          media="(max-width:768px)"
          [attr.srcset]="bannerImage().sm"
          class="ng-star-inserted"
        />
      }
      <img
        loading="lazy"
        [attr.src]="bannerImage().image"
        alt="Test Automated closure"
      />
    </picture>
  </div>

  <div class="fz-banner__root container">
    <div class="fz-banner__inner">
      <!-- Game Avatar -->
      <div id="banner_game_avatar" class="fz-banner__game_avatar">
        <picture>
          @if (game) {
            <img
              [src]="gameImageUrl"
              fzSrcError="/shared/img/all-sports.webp"
            />
          }
        </picture>
      </div>

      <!-- Tournament content -->
      <div class="fz-banner__content">
        @if (
          isLifeExperience && startTime && endTime && !isCompleted && !isEnded
        ) {
          <div class="fz-banner__countdown">
            <fz-tournament-countdown
              [startDate]="startTime"
              [endDate]="endTime"
              [isEnded]="isCompleted"
              [timeZone]="timeZone"
              (handleEvent)="onEvent($event)"
            ></fz-tournament-countdown>
          </div>
        }

        <!-- Title -->
        <h1 class="fz-banner__title" id="banner_tournament_title">
          {{ title }}
          @if (isGameHistoryDetails) {
            <span class="tournament-type-badge mat-caption">
              {{ isLifeExperience ? 'Prize' : 'Cash' }} Tournament
            </span>
          }
        </h1>

        <!-- Subtitle -->
        <p class="fz-banner__subtitle" id="banner_tournament_subtitle">
          {{ subtitle }}
        </p>

        <!-- Dates, for now is only visible when use on sliders -->
        @if (startTime && endTime) {
          <div class="fz-banner__dates mat-label-medium" id="banner_times">
            <div
              class="fz-banner__date mat-label-large"
              matTooltip="{{ startTime | fzDateFormat: 'local' | async }}"
              matTooltipClass="info-tooltip"
            >
              <mat-icon>alarm</mat-icon>
              <span>
                From:
                <span class="large-date">{{
                  startTime | fzDateFormat: 'local' | async
                }}</span>
              </span>
            </div>
            <div
              class="fz-banner__date mat-label-large"
              matTooltip="{{ endTime | fzDateFormat: 'local' | async }}"
              matTooltipClass="info-tooltip"
            >
              <mat-icon>alarm_on</mat-icon>
              <span>
                To:
                <span class="large-date">{{
                  endTime | fzDateFormat: 'local' | async
                }}</span>
              </span>
            </div>
          </div>
        }

        <!-- Actions -->
        @if (!isGameHistoryDetails) {
          <div class="fz-banner__actions" id="banner_actions">
            <fz-tournament-controls
              [vipVideo]="vipVideo"
              [showMoreOptions]="!hideMoreOptions"
              [showJoinButton]="actionBarOptions.showJoinButton"
              [showPlayButton]="actionBarOptions.showPlayButton"
              [enabledPlayButton]="actionBarOptions.enabledPlayButton"
              [playButtonLoading]="actionBarOptions.playButtonLoading"
              [playButtonProcessing]="actionBarOptions.playButtonProcessing"
              [isEventPage]="actionBarOptions.isEventPage"
              [showTryForFreeButton]="true"
              [showShareButton]="actionBarOptions.showShareButton"
              [showPlayButtonAnother]="actionBarOptions.showPlayButtonAnother"
              [isGameOverPage]="actionBarOptions.isGameOverPage"
              [casualGameStartTime]="startTime"
              [casualGameEndTime]="endTime"
              [entryAmount]="entryAmount"
              [eventScheduler]="eventScheduler"
              [user]="user"
              [tournament]="tournament"
              [tournamentDetails]="tournamentDetails"
              [responsive]="true"
              [playText]="playText"
              [timesPlayed]="timesPlayed"
              [activePass]="passForTournament"
              (joinPress)="onJoinButtonPress()"
              (sharePress)="onShareButtonPress()"
              (playPress)="onPlayButtonPress()"
              (tryForFreePress)="onTryForFreePress()"
              (promotionalVideo)="openPromotionalVideo()"
              (playAnotherPress)="onPlayAnotherPress()"
            >
            </fz-tournament-controls>
          </div>
        }
      </div>

      <!-- Prize -->
      @if (prizeDetail) {
        <div class="fz-banner__prize">
          <picture>
            <img [src]="prizeImage()" alt="Prize image" />
          </picture>
        </div>
      }
    </div>
  </div>
</div>

@if (useFloatingBanner()) {
  <div
    id="floating_banner_el"
    class="floating-banner"
    [class.floating-banner--show]="showFloatingBanner()"
    [style.background-image]="'url(' + backgroundImageUrl + ')'"
  >
    <div id="banner_overlay" class="overlay"></div>
    <div class="container">
      <div class="banner_overlay__title">
        <img
          class="game-avatar"
          [attr.src]="gameImageUrl"
          height="42"
          width="42"
        />
        <h1 class="mat-title-large">{{ title }}</h1>
      </div>
      <div class="actions">
        <fz-tournament-controls
          [vipVideo]="vipVideo"
          [showMoreOptions]="!hideMoreOptions"
          [showJoinButton]="actionBarOptions.showJoinButton"
          [showPlayButton]="actionBarOptions.showPlayButton"
          [enabledPlayButton]="actionBarOptions.enabledPlayButton"
          [playButtonLoading]="actionBarOptions.playButtonLoading"
          [playButtonProcessing]="actionBarOptions.playButtonProcessing"
          [isRoomPage]="actionBarOptions.isEventPage"
          [showTryForFreeButton]="true"
          [showShareButton]="actionBarOptions.showShareButton"
          [showPlayButtonAnother]="actionBarOptions.showPlayButtonAnother"
          [isGameOverPage]="actionBarOptions.isGameOverPage"
          [casualGameStartTime]="startTime"
          [casualGameEndTime]="endTime"
          [entryAmount]="entryAmount"
          [eventScheduler]="eventScheduler"
          [user]="user"
          [tournament]="tournament"
          [tournamentDetails]="tournamentDetails"
          [responsive]="true"
          [playText]="playText"
          [timesPlayed]="timesPlayed"
          [activePass]="passForTournament"
          analyticKeyPrefix="floating_banner_"
          (joinPress)="onJoinButtonPress()"
          (sharePress)="onShareButtonPress()"
          (playPress)="onPlayButtonPress()"
          (tryForFreePress)="onTryForFreePress()"
          (promotionalVideo)="openPromotionalVideo()"
          (playAnotherPress)="onPlayAnotherPress()"
        >
        </fz-tournament-controls>
      </div>
    </div>
  </div>
}
